import type { CatalogPlan, PaidPlanId, PlanId } from './types'

export async function sleep(delayMs: number) {
  return new Promise((resolve) => setTimeout(resolve, delayMs))
}

export const isPaidPlan = (planId?: PlanId | null): planId is PaidPlanId =>
  planId === 'pro' || planId === 'team'

export const isFreePlan = (planId?: PlanId | null) => !planId || planId === 'free'

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 })
const integer = new Intl.NumberFormat('en')

export const formatCount = (value: number | null | undefined) =>
  value == null ? 'Unlimited' : integer.format(Math.round(value))

export const formatCompact = (value: number | null | undefined) =>
  value == null ? 'Unlimited' : compact.format(value)

export const formatGb = (value: number | null | undefined) => {
  if (value == null) return 'Unlimited'
  const digits =
    value >= 100 ? 0
    : value >= 10 ? 1
    : 2
  return `${Number(value.toFixed(digits))} GB`
}

const usdWhole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})
const usdCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

export const formatUsd = (value: number) => (Number.isInteger(value) ? usdWhole : usdCents).format(value)

export const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })

export const usagePercent = (used: number, included: number | null) =>
  included == null || included <= 0 ? 0 : Math.min((used / included) * 100, 100)

export const defaultSpendCap = (plan?: CatalogPlan) =>
  plan?.price && plan.defaultSpendCapMultiplier ? plan.defaultSpendCapMultiplier * plan.price.month : null

/** Months a yearly price saves over twelve monthly payments. */
export const yearlyFreeMonths = (plan?: CatalogPlan) => {
  if (!plan?.price || plan.price.month <= 0) return 0
  return Math.round((plan.price.month * 12 - plan.price.year) / plan.price.month)
}
